export default "__VITE_ASSET__DS0hNrwH__"